// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3SB6I","upload":"Small_upload__3Z8Se","imageWrap":"Small_imageWrap__8Dcwp","removeBtn":"Small_removeBtn__O9m9t"};